export function buildTasksPageURL() {
  return '/tasks'
}
